/**
 * Meta Pixel helpers — used only from public pages.
 *
 * The base loader lives in /public/index.html wrapped in a `!location.pathname
 * .startsWith('/admin')` guard, so it never runs when the app is served under
 * /admin/*. These helpers mirror the same guard defensively in case a public
 * component ever gets rendered from a sub-route we forgot about.
 */
const PIXEL_ID = "2327443554726791";

function isPublicPath() {
  if (typeof window === "undefined") return false;
  return !window.location.pathname.startsWith("/admin");
}

/**
 * Lazily inject the Meta Pixel snippet if the user landed on /admin/* first
 * (where the base loader skipped) and then navigated client-side into a
 * public route. Safe to call multiple times — no-op if fbq already exists.
 */
function ensurePixelLoaded() {
  if (typeof window === "undefined") return;
  if (window.fbq) return;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', PIXEL_ID);
  /* eslint-enable */
}

/** Fires a PageView. Called on every SPA route change from App.js. */
export function trackPageView() {
  if (!isPublicPath()) return;
  ensurePixelLoaded();
  if (window.fbq) window.fbq("track", "PageView");
}

/**
 * Fires the standard 'Lead' event. Called from each public form's success
 * handler. `params` is optional and forwarded verbatim to fbq (content_name,
 * content_category, value…).
 */
export function trackLead(params) {
  if (!isPublicPath()) return;
  ensurePixelLoaded();
  if (window.fbq) {
    if (params && typeof params === "object") window.fbq("track", "Lead", params);
    else window.fbq("track", "Lead");
  }
}
